import i18n, { dateLocale } from "../i18n";

// Y axis with round steps (1, 2, 2.5 or 5 × 10ⁿ) that cover the data, so the
// labels read 0, 0.2, 0.4… instead of 0.1625, 0.325…
export const niceAxis = (min, max, count = 5) => {
  if (min == null || max == null) return { domain: ["auto", "auto"] };
  if (min === max) {
    // All values the same: center the single value with some padding.
    return { domain: [min - 1, min + 1], ticks: [min - 1, min, min + 1] };
  }

  const rough = (max - min) / (count - 1);
  const power = 10 ** Math.floor(Math.log10(rough));
  const step =
    [1, 2, 2.5, 5, 10].map((m) => m * power).find((s) => s >= rough) ??
    10 * power;
  const start = Math.floor(min / step) * step;
  const end = Math.ceil(max / step) * step;

  const ticks = [];
  // Rounding keeps floating-point noise (0.30000000000000004) out of labels.
  for (let t = start; t <= end + step / 2; t += step) {
    ticks.push(Math.round(t * 1e6) / 1e6);
  }
  return { domain: [ticks[0], ticks[ticks.length - 1]], ticks };
};

// "2026-03-12" → "12 Mar 26": short enough to sit under the chart.
// In the current language (Arabic month names in Arabic).
export const formatChartDate = (ymd) => {
  const date = new Date(`${ymd}T00:00:00`);
  return Number.isNaN(date.getTime())
    ? ymd
    : date.toLocaleDateString(dateLocale(i18n.resolvedLanguage), {
        day: "numeric",
        month: "short",
        year: "2-digit",
      });
};

export const chartDateAxis = () =>
  i18n.resolvedLanguage === "ar"
    ? {
        tickFormatter: (ymd) => `\u202B${formatChartDate(ymd)}\u202C`,
        minTickGap: 28,
      }
    : { tickFormatter: formatChartDate, minTickGap: 16 };
